const purpleStripeSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4428.76 572.34"><defs><linearGradient id="purpleStripe" x1="-145.43" y1="545.7" x2="5305.56" y2="545.7" gradientTransform="matrix(1.18, 0.07, -0.12, 1.04, -728.09, -467.03)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" /><stop offset="0.26" stop-color="#e8e1fe" /><stop offset="0.63" stop-color="#c1b0fc" /></linearGradient></defs><polygon fill="url(#purpleStripe)" points="4428.11 0.53 119.19 191.97 0.69 571.8 4343.85 341.7 4428.11 0.53" /></svg>';

const rocketSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 585.62 502.45"><defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#016680;}.cls-3,.cls-4{fill:none;stroke:#eff0f0;stroke-miterlimit:10;}.cls-3{stroke-width:1.8px;}.cls-4{stroke-width:1.32px;}.cls-5{fill:#ff7a71;}.cls-6{fill:#eff0f0;}</style><linearGradient id="linear-gradient" x1="-127.05" y1="276.96" x2="535.29" y2="276.96" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset="0.01" stop-color="#fefefe" stop-opacity="0.02"/><stop offset="0.09" stop-color="#eff0f0" stop-opacity="0.2"/><stop offset="0.34" stop-color="#eff0f0" stop-opacity="0.18"/><stop offset="0.61" stop-color="#eff0f0" stop-opacity="0.13"/><stop offset="0.9" stop-color="#eff0f0" stop-opacity="0.04"/><stop offset="0.99" stop-color="#eff0f0" stop-opacity="0"/></linearGradient></defs><polygon class="cls-1" points="142.63 502.45 535.29 51.47 0 502.45 142.63 502.45"/><path class="cls-2" d="M527.92,33.93c-4.16,6.16-7,12-7.57,17.48-.37,3.7-.43,3.23,4.54,8.28,5.13,5.22,4.56,5.45,8.65,4.94,5.3-.65,11.34-3.58,17.15-7.56C590.2,30,585.44.11,585.44.11S553.34-3.72,527.92,33.93Z"/><circle  class="cls-3" cx="559.47" cy="25.81" r="8.42" transform="translate(142.55 399.78) rotate(-44.53)"/><polygon class="cls-2" points="535.52 28.83 521.64 31.26 505.64 47 522.09 45.58 535.52 28.83"/><polygon class="cls-2" points="556.81 49.94 554.16 63.78 538.16 79.52 539.85 63.1 556.81 49.94"/><path class="cls-4" d="M583.54,15s-9.75-3.72-13.24-13.45"/><rect class="cls-2" x="515.04" y="60.81" width="14.36" height="4.34" rx="1.14" ry="1.14" transform="translate(843.57 479.4) rotate(-134.53)"/><path class="cls-5" d="M524,71.65a10.76,10.76,0,0,1-5.62,10.21C513,85,498.9,85.69,498.9,85.69s1.88-11.21,4.78-17.78c3.65-8.26,10.63-6.26,10.63-6.26Z"/><path class="cls-6" d="M521.75,69.3a5.81,5.81,0,0,1-3,5.51c-2.9,1.69-10.52,2.07-10.52,2.07a51.16,51.16,0,0,1,2.58-9.6c2-4.46,5.74-3.38,5.74-3.38Z"/></svg>';

export default theme => ({
  root: {
    position: 'relative'
  },
  // Billing type
  billingType: {
    marginTop: (theme.spacing.unit * 5) + 20,
    textAlign: 'center',
    position: 'relative'
  },
  billingTypeButton: {
    width: 120,
    backgroundColor: theme.palette.background.contentFrame,
    border: 0,
    borderRadius: '0 2px 2px 0',
    color: '#000',
    display: 'inline-block',
    height: 36,
    lineHeight: '32px',
    margin: `0 ${theme.spacing.unit / 2}px`,
    textTransform: 'uppercase',
    transitionDuration: theme.transitions.duration.short,
    transitionProperty: 'color, background-color',
    transitionTimingFunction: theme.transitions.easing.easeIn,
    '&:first-child': {
      borderRadius: '2px 0 0 2px'
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.A400,
      color: '#fff'
    }
  },
  billingTypeButtonActive: {
    backgroundColor: theme.palette.secondary.A400,
    color: '#fff'
  },
  billingTypeOr: {
    backgroundColor: '#fff',
    borderRadius: '50%',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    height: 30,
    left: '50%',
    lineHeight: '30px',
    position: 'absolute',
    textAlign: 'center',
    top: 3,
    transform: 'translateX(-50%)',
    width: 30,
  },
  // Plans
  plansProgress: {
    textAlign: 'center',
    paddingTop: theme.spacing.unit * 10,
    paddingBottom: theme.spacing.unit * 40
  },
  plans: {
    position: 'relative',
    marginTop: theme.spacing.unit * 5,
  },
  plan: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
    }
  },
  planInner: {
    height: '100%',
    padding: `${theme.spacing.unit * 5}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
    transitionProperty: 'box-shadow, transform',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeIn,
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[10]
    }
  },
  planIcon: {
    width: 30,
    height: 30,
    display: 'inline-block',
    marginBottom: theme.spacing.unit
  },
  planTitle: {
    font: '600 23px/28px "Open Sans"',
    marginBottom: theme.spacing.unit * 2
  },
  planPrice: {
    font: '300 30px/36px "Open Sans"',
    color: theme.palette.primary['500']
  },
  planPriceHint: {
    marginBottom: theme.spacing.unit * 2
  },
  planDescription: {
    marginBottom: theme.spacing.unit * 2,
    [theme.breakpoints.up('lg')]: {
      whiteSpace: 'pre-wrap'
    }
  },
  planButton: {
    marginBottom: theme.spacing.unit * 2,
    backgroundColor: 'transparent',
    border: '2px solid #6E40DD',
    borderRadius: 2,
    color: '#6E40DD',
    display: 'inline-block',
    height: 36,
    lineHeight: '32px',
    padding: `0 ${theme.spacing.unit * 2}px`,
    textTransform: 'uppercase',
    transitionProperty: 'border-color, background-color, color',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeIn,
    '&:hover': {
      color: '#fff',
      backgroundColor: '#6E40DD',
      borderColor: 'transparent'
    }
  },
  planDivider: {
    marginBottom: theme.spacing.unit * 2
  },
  planSchoolsLabel: {
    font: '600 12px/15px "Open Sans"',
    textTransform: 'uppercase',
    marginBottom: theme.spacing.unit * 2,
    [theme.breakpoints.up('lg')]: {
      whiteSpace: 'pre-wrap'
    }
  },
  planFeaturesTitle: {
    font: '600 16px/20px "Open Sans"',
    textTransform: 'uppercase',
    marginBottom: theme.spacing.unit * 2
  },
  planFeatures: {
    textAlign: 'left'
  },
  planFeature: {
    position: 'relative',
    paddingLeft: 24 + theme.spacing.unit,
    '&:not(:last-child)': {
      marginBottom: theme.spacing.unit * 2
    }
  },
  planFeatureCheck: {
    position: 'absolute',
    top: '-0.15em',
    left: 0,
    fill: theme.palette.primary['500']
  },
  // Purple stripe
  purpleStripe: {
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(purpleStripeSvg)}')`,
      position: 'center center',
      repeat: 'no-repeat',
      size: 'cover'
    },
    marginTop: -300,
    padding: '340px 0 180px',
    [theme.breakpoints.up('md')]: {
      textAlign: 'center'
    }
  },
  purpleStripeButton: {
    backgroundColor: 'transparent',
    border: '2px solid #fff',
    borderRadius: 2,
    color: '#fff',
    display: 'inline-block',
    height: 36,
    lineHeight: '32px',
    padding: `0 ${theme.spacing.unit * 2}px`,
    textTransform: 'uppercase',
    transitionProperty: 'border-color, background-color',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeIn,
    '&:hover': {
      backgroundColor: theme.palette.primary['500'],
      borderColor: 'transparent'
    }
  },
  // FAQ
  faq: {
    position: 'relative',
    zIndex: 1,
    maxWidth: 800
  },
  faqTitle: {
    font: '300 30px/35px "Open Sans"',
    marginBottom: theme.spacing.unit * 5
  },
  faqItem: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing.unit * 3
    }
  },
  faqItemTitle: {
    position: 'relative',
    paddingRight: 24 + theme.spacing.unit,
    background: 'none',
    border: 0,
    display: 'block',
    font: '300 21px/24px "Open Sans"',
    marginBottom: theme.spacing.unit,
    padding: 0,
    textAlign: 'left',
    width: '100%',
    '&:focus': {
      outline: 'none'
    }
  },
  faqItemTitleArrow: {
    position: 'absolute',
    right: 0,
    fill: theme.palette.primary['500']
  },
  faqItemAnswer: {
    paddingTop: theme.spacing.unit
  },
  // Footer
  footerContainer: {
    position: 'relative'
  },
  footerRocket: {
    width: 585,
    height: 502,
    position: 'absolute',
    left: '50%',
    bottom: 0,
    zIndex: 0,
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(rocketSvg)}')`,
      position: 'center top',
      repeat: 'no-repeat',
      size: 'cover'
    }
  }
});



// WEBPACK FOOTER //
// ./src/pages/Pricing/styles.js